import { ResultFileType } from '@consigli/types';

/**
 * Automatically detects the file type based on filename and extension
 * @param filename The filename to analyze
 * @returns The detected ResultFileType
 */
export const getFileTypeFromFilename = (filename: string): ResultFileType => {
  const originalName = filename.toLowerCase();
  const extension = filename.split('.').pop()?.toLowerCase();

  // Helper function to check if filename contains all words (any order)
  const hasWords = (...words: string[]) => words.every((word) => originalName.includes(word));

  // Check extensions first
  if (extension === 'xls' || extension === 'xlsx') return ResultFileType.REPORTS;
  if (extension === 'ifc') return ResultFileType.IFC;
  if (extension === 'rvt') return ResultFileType.REVIT;
  if (extension === 'ldt') return ResultFileType.LUMINAIRE;

  // Check filename patterns (most specific first)
  if (hasWords('combined', 'service') || hasWords('combined', 'services'))
    return ResultFileType.DRAWINGS_2D;
  if (hasWords('acoustic')) return ResultFileType.ACOUSTIC_REPORT;
  if (hasWords('fire')) return ResultFileType.FIRE_REPORT;
  if (hasWords('commissioning')) return ResultFileType.COMMISSIONING_REPORT;
  if (hasWords('ventilation', 'zoning') || hasWords('zoning')) return ResultFileType.STRATEGIES;
  if (hasWords('lightning', 'levels') || hasWords('lightning')) return ResultFileType.STRATEGIES;
  if (hasWords('ventilation', 'rate') || hasWords('ventilation'))
    return ResultFileType.VENTILATION_RATES;

  return ResultFileType.OTHERS;
};
